import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { showSuccessSnackbar } from 'modules/snackbar';

import BrowserBarGraph from './BrowserBarGraph';
import BrowserPieGraph from './BrowserPieGraph';
import BrowserDayGraph from './BrowserDayGraph';
import ChartButtonWrap from 'components/molecules/ChartButtonWrap';
import OutlinedButton from 'components/atoms/OutlinedButton';

const useStyles = makeStyles((theme) => ({
  contentBox: {
    width: '100%',
    display: 'flex',
    paddingBottom: 20,
  },
  pieGraphBox: {
    width: '30%',
    height: 500,
  },
  barGraphBox1: {
    width: '70%',
    marginLeft: 17,
    height: 500,
  },
  barGraphBox2: {
    width: '70%',
    marginLeft: 17,
    height: 500,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  dailyGraphBox: {
    paddingTop: 30,
  },
}));
const BrowserGraph = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const classes = useStyles();
  const [initialization, setInitialization] = useState(false);

  const { dataReqPromise = (f) => f, params } = props;

  const [graphData, setGraphData] = useState();
  const [selectGraphData, setSelectGraphData] = useState();
  const [graphIndex, setGraphIndex] = useState(0);
  const [graphOptionList, setGraphOptionList] = useState();
  const [graphLoading, setGraphLoading] = useState(true);

  const graphList = [
    {
      title: '노출',
      key: 'PAR_EPRS_CNT',
      chart: {
        type: 'column',
      },
    },
    {
      title: '클릭',
      key: 'CLICK_CNT',
      chart: {
        type: 'column',
      },
    },
    {
      title: '지출금액',
      key: 'ADVRTS_AMT',
      chart: {
        type: 'column',
      },
    },
    {
      title: '반송',
      key: 'RETRN_CNT',
      chart: {
        type: 'column',
      },
    },
    {
      title: '유효',
      key: 'AVAL_CNT',
      chart: {
        type: 'column',
      },
    },
    {
      title: '전환',
      key: 'ORDER_CNT',
      chart: {
        type: 'column',
      },
    },
    {
      title: t('세션ROAS'),
      key: 'SESSION_ROAS',
      chart: {
        type: 'spline',
      },
    },
    {
      title: t('결제ROAS'),
      key: 'MOB_SESSION_ROAS',
      chart: {
        type: 'spline',
      },
    },
    {
      title: t('직접ROAS'),
      key: 'DIRECT_ROAS',
      chart: {
        type: 'spline',
      },
    },
    {
      title: t('총ROAS'),
      key: 'ROAS',
      chart: {
        type: 'spline',
      },
    },
  ];

  /*
   * 그래프 api
   */
  useEffect(() => {
    const newParams = { ...params };
    if (newParams['pltfomTpCode'] === 'all') {
      delete newParams['pltfomTpCode'];
    }
    delete newParams['category'];
    setGraphLoading(true);
    dataReqPromise(newParams)
      .then((response) => {
        const { data } = response.data;
        setGraphData(data);
        setSelectGraphData(data['PAR_EPRS_CNT']);
        setGraphOptionList(graphList[0]);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        setGraphLoading(false);
        setGraphIndex(0);
      });
    //eslint-disable-next-line
  }, [params]);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const handleChangeGraph = (item, index) => {
    setGraphOptionList(item);
    //버튼 클릭시 변경
    setGraphIndex(index);
    setSelectGraphData(graphData[item.key]);
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <ChartButtonWrap>
        {graphList.map((item, index) => {
          return (
            <OutlinedButton
              key={index}
              onClick={() => handleChangeGraph(item, index)}
              selected={graphIndex === index}
            >
              {item.title}
            </OutlinedButton>
          );
        })}
      </ChartButtonWrap>
      <div className={classes.contentBox}>
        <div className={classes.pieGraphBox}>
          <BrowserPieGraph
            params={params}
            pieData={selectGraphData}
            loading={graphLoading}
          />
        </div>
        <div className={classes.barGraphBox1}>
          <BrowserBarGraph
            params={params}
            barData={selectGraphData}
            loading={graphLoading}
          />
        </div>
      </div>
      <div className={classes.dailyGraphBox}>
        <BrowserDayGraph
          params={params}
          barData={selectGraphData}
          graphOptionList={graphOptionList}
          loading={graphLoading}
        />
      </div>
    </>
  );
};

export default BrowserGraph;
